import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index.js";
import multiguard from "vue-router-multiguard";
import http from "../utils/http-common";
import Swal from "sweetalert2";
import { jwtDecode } from "jwt-decode";
import i18n from "@/i18n"
import { DEFAULT_SORT_JSON } from '../store/constants/userInfoSortJsonDefault'
import { isLicenseActiveError, refreshAccessTokenAsMethodRecall } from "@/utils/auth-service";
import { isCookieRefreshEnabled } from "@/utils/auth-tokens";
import { applyConsolePolicy } from "@/utils/console-policy";
import { canAccessProjectMenu } from "@/utils/menu-permission";
import Help from "../views/Help.vue";

Vue.use(VueRouter);

let keepSwalOnNextRouteChange = false
let hasFetchedUserInfoAfterBoot = false

function normalizeAuthorizedDownloadUrl(url) {
  if (!url) return ''
  return String(url)
    .trim()
    .replace(/^\/?api\/v0\//, '')
    .replace(/^\/+/, '')
}

function methodRecall() { // main.js, mutations.js, actions.js, index.js(router) 공유
  return refreshAccessTokenAsMethodRecall();
}

function applyUserInfoResponse(res) {
  console.log('getUserInfo res', res)
  if (!res.data.sort_json) {
    res.data.sort_json = { ...DEFAULT_SORT_JSON }
  }
  if (!res.data.language) {
    res.data.language = 'ko'
  }
  i18n.locale = res.data.language
  i18n.fallbackLocale  = res.data.language
  // 기한 만료 n일 이내인 경우
  if (res.data.license_block >= 0) {
    // 무료체험 계정인 경우
    if (res.data.plan === 'trial') {
      if (res.data.sort_json.expireDateEndDialog || res.data.sort_json.expireDateEndDialog === null || res.data.sort_json.expireDateEndDialog === undefined) {
        res.data.sort_json.expireDateEndDialog = true
      }
      if (res.data.sort_json.expireDateEndAlert || res.data.sort_json.expireDateEndAlert === null || res.data.sort_json.expireDateEndAlert === undefined) {
        res.data.sort_json.expireDateEndAlert = true
      }
    }
    // 엔터프라이즈 계정인 경우
    else {
      res.data.sort_json.expireDateEndDialog = false
      if (res.data.sort_json.expireDateEndAlert || res.data.sort_json.expireDateEndAlert === null || res.data.sort_json.expireDateEndAlert === undefined) {
        res.data.sort_json.expireDateEndAlert = true
      }
    }
  } else {
    res.data.sort_json.expireDateEndDialog = false
    res.data.sort_json.expireDateEndAlert = false
  }
  store.dispatch('updateUserInfo', res.data)
  hasFetchedUserInfoAfterBoot = true
  applyConsolePolicy(store.state.user_info.organization_permission)
}

function fetchUserInfo() {
  return http
    .get('account/user/', { headers: { Authorization: 'Bearer ' + store.state.access_token } })
    .then(res => {
      applyUserInfoResponse(res)
    })
    .catch(err => {
      console.log(err)
      console.log(err.response)
      if (!(err.response && err.response.status === 401)) {
        throw err
      }
      return methodRecall()
        .then(msg => {
          console.log(msg)
          return http
            .get('account/user/', { headers: { Authorization: 'Bearer ' + store.state.access_token } })
            .then(res => {
              applyUserInfoResponse(res)
            })
        })
    })
}

const onlyAfterLogin = (to, from, next) => {
  console.log('onlyAfterLogin', to, from, next)
  if (store.getters.isLoggedIn === false) {
    Swal.mixin({
      toast: true,
      showClass: { popup: 'animate__animated animate__fadeInDown' },
      hideClass: { popup: 'animate__animated animate__fadeOutUp' },
      position: 'top',
      showConfirmButton: false,
      timer: store.getters.toastTimer,
      timerProgressBar: false,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    }).fire({
      icon: "warning",
      iconColor: "#ffc107",
      title: "<div style='font-size: 16px; color: #0D0E17'>로그인해 주세요.<div>",
      width: store.getters.toastWidth,
      background: store.getters.toastBgColor
    })
    next({ path: "/", });
  } else {
    if (hasFetchedUserInfoAfterBoot && Object.keys(store.state.user_info).length > 0) {
      applyConsolePolicy(store.state.user_info.organization_permission)
      next();
    }
    else {
      // 유저 정보 호출 및 저장
      fetchUserInfo()
      .then(() => {
        next();
      })
      .catch(err => {
        console.log(err)
        console.log(err.response)
        store.commit('setOverlay', false)
        store.commit('setOverlayText', '')
        if (isLicenseActiveError(err)) {
          store.commit('logout')
          next('/');
          return;
        }
        Swal.mixin({
          toast: true,
          showClass: { popup: 'animate__animated animate__fadeInDown' },
          hideClass: { popup: 'animate__animated animate__fadeOutUp' },
          position: 'top',
          showConfirmButton: false,
          timer: store.getters.toastTimer,
          timerProgressBar: false,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        }).fire({
          icon: "warning",
          iconColor: "#ffc107",
          title: "<div style='font-size: 16px; color: #0D0E17'>데이터를 불러오는 데 실패했습니다.<div>",
          width: store.getters.toastWidth,
          background: store.getters.toastBgColor
        })
        store.commit('logout')
        next('/');
      })
    }
  }
};
const onlyBeforeLogin = (to, from, next) => {
  console.log('onlyBeforeLogin', to, from, next)
  if (store.getters.isLoggedIn === true) {
    Swal.mixin({
      toast: true,
      showClass: { popup: 'animate__animated animate__fadeInDown' },
      hideClass: { popup: 'animate__animated animate__fadeOutUp' },
      position: 'top',
      showConfirmButton: false,
      timer: store.getters.toastTimer,
      timerProgressBar: false,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    }).fire({
      icon: "warning",
      iconColor: "#ffc107",
      title: "<div style='font-size: 16px; color: #0D0E17'>로그인한 사용자는 이용할 수 없는 페이지입니다.<div>",
      width: store.getters.toastWidth,
      background: store.getters.toastBgColor
    })
    next({ path: "/", });
  } else {
    next();
  }
};
const onlyOwner = (to, from, next) => {
  console.log('onlyOwner', to, from, next)
  if (store.state.current_project.level < 3) {
    Swal.mixin({
      toast: true,
      showClass: { popup: 'animate__animated animate__fadeInDown' },
      hideClass: { popup: 'animate__animated animate__fadeOutUp' },
      position: 'top',
      showConfirmButton: false,
      timer: store.getters.toastTimer,
      timerProgressBar: false,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    }).fire({
      icon: "warning",
      iconColor: "#ffc107",
      title: "<div style='font-size: 16px; color: #0D0E17'>권한이 없습니다.<div>",
      width: store.getters.toastWidth,
      background: store.getters.toastBgColor
    })
    next("/workspace");
  } else {
    next();
  }
};
const onlySuperAdmin = (to, from, next) => {
  console.log('onlySuperAdmin', to, from, next)
  if (store.state.user_info.organization_permission !== 'super_admin') {
    Swal.mixin({
      toast: true,
      showClass: { popup: 'animate__animated animate__fadeInDown' },
      hideClass: { popup: 'animate__animated animate__fadeOutUp' },
      position: 'top',
      showConfirmButton: false,
      timer: store.getters.toastTimer,
      timerProgressBar: false,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    }).fire({
      icon: "warning",
      iconColor: "#ffc107",
      title: "<div style='font-size: 16px; color: #0D0E17'>권한이 없습니다.<div>",
      width: store.getters.toastWidth,
      background: store.getters.toastBgColor
    })
    next("/workspace");
  } else {
    next();
  }
};
const redirectWorkspace = (to, from, next) => {
  console.log('redirectWorkspace', to, from, next)
  if (store.getters.isLoggedIn === true) {
    applyConsolePolicy(store.state.user_info.organization_permission)
    next({ path: "/workspace", });
  } else {
    applyConsolePolicy()
    next();
  }
};

const checkPjt = (to, from, next) => {
  console.log('checkPjt', to, from, next)
  if ('pk' in to.params) {
    console.log('setCurrentProjectPk', Number(to.params.pk))
    store.commit('setCurrentProjectPk', Number(to.params.pk))
    // 프로젝트 정보 호출 및 저장
    http
    .get(`annotation/get-project-list/${store.state.current_project_pk}/`, { headers: { Authorization: 'Bearer ' + store.state.access_token } })
    .then(res => {
      console.log('get-project-list res', res)
      // 대표 이미지 관련
      if (res.data.icon_url) {
        res.data.icon_url = normalizeAuthorizedDownloadUrl(res.data.icon_url)
      }
      checkPjtFunction(to, from, next, res)
    })
    .catch(err => {
      console.log(err)
      console.log(err.response)
      if (err.response && err.response.status === 401) { // access token 만료
        methodRecall()
        .then(msg => {
          console.log(msg)
          // method 재호출
          http
          .get(`annotation/get-project-list/${store.state.current_project_pk}/`, { headers: { Authorization: 'Bearer ' + store.state.access_token } })
          .then(res => {
            if (res.data.icon_url) {
              res.data.icon_url = normalizeAuthorizedDownloadUrl(res.data.icon_url)
            }
            checkPjtFunction(to, from, next, res)
          })
        })
        .catch(err_msg => {
          console.log(err_msg)
          store.commit('setOverlay', false)
          store.commit('setOverlayText', '')
          if (err_msg === 0) {
            console.log('BE에 access token 저장 실패')
          } else { // err_msg === 1
            console.log('refresh token 만료(access token 갱신 실패)')
            // store.commit('swalToast', {title: '다시 로그인해 주세요.', type: 'warning'})
            store.commit('logout')
            next('/');
          }
        })
      } else {
        Swal.mixin({
          toast: true,
          showClass: { popup: 'animate__animated animate__fadeInDown' },
          hideClass: { popup: 'animate__animated animate__fadeOutUp' },
          position: 'top',
          showConfirmButton: false,
          timer: store.getters.toastTimer,
          timerProgressBar: false,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        }).fire({
          icon: "warning",
          iconColor: "#ffc107",
          title: "<div style='font-size: 16px; color: #0D0E17'>잘못된 주소입니다.<div>",
          width: store.getters.toastWidth,
          background: store.getters.toastBgColor
        })
        next("/workspace");
      }
    })
  } else { // pk가 없을 경우
    Swal.mixin({
      toast: true,
      showClass: { popup: 'animate__animated animate__fadeInDown' },
      hideClass: { popup: 'animate__animated animate__fadeOutUp' },
      position: 'top',
      showConfirmButton: false,
      timer: store.getters.toastTimer,
      timerProgressBar: false,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    }).fire({
      icon: "warning",
      iconColor: "#ffc107",
      title: "<div style='font-size: 16px; color: #0D0E17'>잘못된 주소입니다.<div>",
      width: store.getters.toastWidth,
      background: store.getters.toastBgColor
    })
    next("/workspace");
  }
};
function checkPjtFunction(to, from, next, res) {
  console.log('checkPjtFunction', to, from, next, res)
  
  console.log('checkPjt - 프로젝트 정보 호출 및 저장', res)
  console.log('setCurrentProject', res.data)
  store.commit('setCurrentProject', res.data)
  store.commit('setCurrentProjectTitle', res.data.name)

  // 유저 및 프로젝트 종속 정렬
  let params = {
    user: store.state.user_info.pk,
    project: store.state.current_project_pk,
  }
  http
  .get('account/get-sort-item/', { params: params, headers: { Authorization: 'Bearer ' + store.state.access_token } })
  .then(res => {
    console.log('get-sort-item res', res)
    if (!res.data.sort_json) {
      res.data.sort_json = {
        multiTableDataListOrder: '-created_at',
        isFormatMode: false,
      }
    }
    else {
      if (res.data.sort_json.multiTableDataListOrder === null || res.data.sort_json.multiTableDataListOrder === undefined) {
        res.data.sort_json.multiTableDataListOrder = '-created_at'
      }
      if (res.data.sort_json.isFormatMode === null || res.data.sort_json.isFormatMode === undefined) {
        res.data.sort_json.isFormatMode = false
      }
    }
    store.commit('setCurrentProjectSort', res.data.sort_json)
  })

  const menu = to.meta && to.meta.menuKey
  console.log('menu', menu)

  if (!menu || canAccessProjectMenu(menu, store.state.user_info, store.state.current_project)) {
    next();
    return
  }

  Swal.mixin({
    toast: true,
    showClass: { popup: 'animate__animated animate__fadeInDown' },
    hideClass: { popup: 'animate__animated animate__fadeOutUp' },
    position: 'top',
    showConfirmButton: false,
    timer: store.getters.toastTimer,
    timerProgressBar: false,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  }).fire({
    icon: "warning",
    iconColor: "#ffc107",
    title: "<div style='font-size: 16px; color: #0D0E17'>메뉴 권한이 없습니다.<div>",
    width: store.getters.toastWidth,
    background: store.getters.toastBgColor
  })
  keepSwalOnNextRouteChange = true
  next("/workspace");
}

const checkMenuPermission = (to, from, next) => {
  console.log('checkMenuPermission', to, from, next)
  const menu = to.meta && to.meta.menuKey

  if (!menu || canAccessProjectMenu(menu, store.state.user_info, store.state.current_project)) {
    next();
    return
  }

  Swal.mixin({
    toast: true,
    showClass: { popup: 'animate__animated animate__fadeInDown' },
    hideClass: { popup: 'animate__animated animate__fadeOutUp' },
    position: 'top',
    showConfirmButton: false,
    timer: store.getters.toastTimer,
    timerProgressBar: false,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  }).fire({
    icon: "warning",
    iconColor: "#ffc107",
    title: "<div style='font-size: 16px; color: #0D0E17'>메뉴 권한이 없습니다.<div>",
    width: store.getters.toastWidth,
    background: store.getters.toastBgColor
  })
  keepSwalOnNextRouteChange = true
  next("/workspace");
}

const checkRpa = (to, from, next) => {
  console.log('checkRpa', to, from, next)
  if ('rpa_pk' in to.params) {
    const targetRpaId = Number(to.params.rpa_pk)
    const shouldDeferCurrentRpaCommit = (
      from.name === 'RpaMain' &&
      to.name === 'RpaMain' &&
      to.params.rpa_pk !== from.params.rpa_pk
    )
    // rpa 정보 호출 및 저장
    http
    .get(`annotation/rpa-item/${targetRpaId}/`, { headers: { Authorization: 'Bearer ' + store.state.access_token } })
    .then(res => {
      console.log('getRpaItem res', res)
      if (res.data) {
        if (res.data.id === targetRpaId && !shouldDeferCurrentRpaCommit) {
          let copied_data = JSON.parse(JSON.stringify(res.data))
          copied_data.rpa = null
          console.log('setCurrentRpa', copied_data)
          store.commit('setCurrentRpa', copied_data)
        } else if (shouldDeferCurrentRpaCommit) {
          console.log('checkRpa setCurrentRpa defer - RpaMain 내부 워크플로우 전환은 컴포넌트 로드 완료 후 반영', { targetRpaId })
        } else {
          console.log('checkRpa response stale - 요청한 워크플로우와 응답 ID가 다름', { targetRpaId, responseRpaId: res.data.id })
        }
        next();
      } else {
        Swal.mixin({
          toast: true,
          showClass: { popup: 'animate__animated animate__fadeInDown' },
          hideClass: { popup: 'animate__animated animate__fadeOutUp' },
          position: 'top',
          showConfirmButton: false,
          timer: store.getters.toastTimer,
          timerProgressBar: false,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        }).fire({
          icon: "warning",
          iconColor: "#ffc107",
          title: "<div style='font-size: 16px; color: #0D0E17'>잘못된 주소입니다.<div>",
          width: store.getters.toastWidth,
          background: store.getters.toastBgColor
        })
        next("/workspace");
      }
    })
    .catch(err => {
      console.log(err)
      console.log(err.response)
      if (err.response && err.response.status === 401) { // access token 만료
        methodRecall()
        .then(msg => {
          console.log(msg)
          // method 재호출
          return http
          .get(`annotation/rpa-item/${targetRpaId}/`, { headers: { Authorization: 'Bearer ' + store.state.access_token } })
          .then(res => {
            console.log('getRpaItem res', res)
            if (res.data) {
              if (res.data.id === targetRpaId && !shouldDeferCurrentRpaCommit) {
                let copied_data = JSON.parse(JSON.stringify(res.data))
                copied_data.rpa = null
                console.log('setCurrentRpa', copied_data)
                store.commit('setCurrentRpa', copied_data)
              } else if (shouldDeferCurrentRpaCommit) {
                console.log('checkRpa retry setCurrentRpa defer - RpaMain 내부 워크플로우 전환은 컴포넌트 로드 완료 후 반영', { targetRpaId })
              } else {
                console.log('checkRpa retry response stale - 요청한 워크플로우와 응답 ID가 다름', { targetRpaId, responseRpaId: res.data.id })
              }
              next();
            } else {
              Swal.mixin({
                toast: true,
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' },
                position: 'top',
                showConfirmButton: false,
                timer: store.getters.toastTimer,
                timerProgressBar: false,
                didOpen: (toast) => {
                  toast.addEventListener('mouseenter', Swal.stopTimer)
                  toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
              }).fire({
                icon: "warning",
                iconColor: "#ffc107",
                title: "<div style='font-size: 16px; color: #0D0E17'>잘못된 주소입니다.<div>",
                width: store.getters.toastWidth,
                background: store.getters.toastBgColor
              })
              next("/workspace");
            }
          })
          .catch(err => {
            console.log(err)
            console.log(err.response)
            Swal.mixin({
              toast: true,
              showClass: { popup: 'animate__animated animate__fadeInDown' },
              hideClass: { popup: 'animate__animated animate__fadeOutUp' },
              position: 'top',
              showConfirmButton: false,
              timer: store.getters.toastTimer,
              timerProgressBar: false,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
              }
            }).fire({
              icon: "warning",
              iconColor: "#ffc107",
              title: "<div style='font-size: 16px; color: #0D0E17'>잘못된 주소입니다.<div>",
              width: store.getters.toastWidth,
              background: store.getters.toastBgColor
            })
            next("/workspace");
          })
        })
        .catch(err_msg => {
          console.log(err_msg)
          store.commit('setOverlay', false)
          store.commit('setOverlayText', '')
          if (err_msg === 0) {
            console.log('BE에 access token 저장 실패')
          } else { // err_msg === 1
            console.log('refresh token 만료(access token 갱신 실패)')
            // store.commit('swalToast', {title: '다시 로그인해 주세요.', type: 'warning'})
            store.commit('logout')
            next('/');
          }
        })
      } else {
        Swal.mixin({
          toast: true,
          showClass: { popup: 'animate__animated animate__fadeInDown' },
          hideClass: { popup: 'animate__animated animate__fadeOutUp' },
          position: 'top',
          showConfirmButton: false,
          timer: store.getters.toastTimer,
          timerProgressBar: false,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        }).fire({
          icon: "warning",
          iconColor: "#ffc107",
          title: "<div style='font-size: 16px; color: #0D0E17'>잘못된 주소입니다.<div>",
          width: store.getters.toastWidth,
          background: store.getters.toastBgColor
        })
        next("/workspace");
      }
    })
  } else { // rpa_pk가 없을 경우
    Swal.mixin({
      toast: true,
      showClass: { popup: 'animate__animated animate__fadeInDown' },
      hideClass: { popup: 'animate__animated animate__fadeOutUp' },
      position: 'top',
      showConfirmButton: false,
      timer: store.getters.toastTimer,
      timerProgressBar: false,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    }).fire({
      icon: "warning",
      iconColor: "#ffc107",
      title: "<div style='font-size: 16px; color: #0D0E17'>잘못된 주소입니다.<div>",
      width: store.getters.toastWidth,
      background: store.getters.toastBgColor
    })
    next("/workspace");
  }
};

const routes = [
  // 랜딩페이지
  { path: "/", name: "LandingPage",
    component: () => import("../views/LandingPage.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 로그인(대검 전용)
  // { path: "/", name: "LoginProsecution",
  //   component: () => import("../views/LoginProsecution.vue"),
  //   beforeEnter: multiguard([redirectWorkspace]),
  // },
  // 회원가입(대검 전용)
  // { path: "/sign-up-prosecution", name: "SignUpProsecution",
  //   component: () => import("../views/SignUpProsecution.vue"),
  //   beforeEnter: multiguard([onlyBeforeLogin]),
  // },

  // 랜딩페이지 > 제품 > 워크플로우
  { path: "/product-workflow", name: "ProductWorkflow",
    component: () => import("../views/ProductWorkflow.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 제품 > 엑셀 서식
  { path: "/product-excel-format", name: "ProductExcelFormat",
    component: () => import("../views/ProductExcelFormat.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 제품 > 데이터 검증
  { path: "/product-data-verify", name: "ProductDataVerify",
    component: () => import("../views/ProductDataVerify.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 제품 > 문서 폼
  { path: "/product-document-form", name: "ProductDocumentForm",
    component: () => import("../views/ProductDocumentForm.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 제품 > 이메일 유효성 검증
  { path: "/product-email-verify", name: "ProductEmailVerify",
    component: () => import("../views/ProductEmailVerify.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 제품 > 협업 기능
  { path: "/product-cooperation", name: "ProductCooperation",
    component: () => import("../views/ProductCooperation.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 제품 > 시각화 대시보드
  { path: "/product-visualization", name: "ProductVisualization",
    component: () => import("../views/ProductVisualization.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 솔루션 > 이커머스
  { path: "/solution-ecommerce", name: "SolutionEcommerce",
    component: () => import("../views/SolutionEcommerce.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 솔루션 > 유통 ∙ 물류
  { path: "/solution-logistics", name: "SolutionLogistics",
    component: () => import("../views/SolutionLogistics.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 솔루션 > 리테일
  { path: "/solution-retail", name: "SolutionRetail",
    component: () => import("../views/SolutionRetail.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 고객사례
  { path: "/customer-example", name: "CustomerExample",
    component: () => import("../views/CustomerExample.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 고객사례 > 세부 페이지
  { path: "/customer-example/:idx", name: "CustomerExampleDetail",
    component: () => import("../views/CustomerExampleDetail.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 플랜안내
  // { path: "/plan-guide", name: "PlanGuide",
  //   component: () => import("../views/PlanGuide.vue"),
  //   beforeEnter: multiguard([redirectWorkspace]),
  // },
  // 랜딩페이지 > 바우처
  // { path: "/voucher", name: "Voucher",
  //   component: () => import("../views/Voucher.vue"),
  //   beforeEnter: multiguard([redirectWorkspace]),
  // },
  // 랜딩페이지 > 뉴스룸
  { path: "/news-room", name: "NewsRoom",
    component: () => import("../views/NewsRoom.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 뉴스룸 > 세부 페이지
  { path: "/news-room/:idx", name: "NewsRoomDetail",
    component: () => import("../views/NewsRoomDetail.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 도입 문의하기
  { path: "/contact", name: "Contact",
    component: () => import("../views/Contact.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },
  // 랜딩페이지 > 소개서 받아보기
  { path: "/manual-download", name: "ManualDownload",
    component: () => import("../views/ManualDownload.vue"),
    beforeEnter: multiguard([redirectWorkspace]),
  },

  // 회원가입(개인)
  { path: "/sign-up", name: "SignUp",
    component: () => import("../views/SignUp.vue"),
    beforeEnter: multiguard([onlyBeforeLogin]),
  },
  // 회원가입(기업)
  { path: "/sign-up-corporate", name: "SignUpCorporation",
    component: () => import("../views/SignUpCorporation.vue"),
    beforeEnter: multiguard([onlyBeforeLogin]),
  },
  // 회원가입(기업) 구 주소
  { path: "/sign-up-corporate2",
    redirect: "/sign-up-corporate",
  },
  // 이메일 인증
  { path: "/email-confirm/:uidb64/:token", name: "EmailConfirm",
    component: () => import("../views/EmailConfirm.vue"),
    beforeEnter: multiguard([onlyBeforeLogin]),
  },
  // 비밀번호 변경
  { path: "/reset-password-confirm/:uidb64/:token", name: "ResetPasswordConfirm",
    component: () => import("../views/ResetPasswordConfirm.vue"),
    beforeEnter: multiguard([onlyBeforeLogin]),
  },

  // 워크스페이스
  { path: "/workspace", name: "WorkSpace",
    component: () => import("../views/WorkSpace.vue"),
    beforeEnter: multiguard([onlyAfterLogin]),
  },
  // 태그 관리
  { path: "/tag-management", name: "TagManagement",
    component: () => import("../views/TagManagement.vue"),
    beforeEnter: multiguard([onlyAfterLogin]),
  },
  // 전체 AI Agent 목록
  { path: "/total-ai-agent-list", name: "TotalAiAgentList",
    component: () => import("../views/TotalAiAgentList.vue"),
    beforeEnter: multiguard([onlyAfterLogin]),
  },

  // 팀 관리
  { path: "/team-management", name: "TeamManagement",
    component: () => import("../views/TeamManagement.vue"),
    beforeEnter: multiguard([onlyAfterLogin]),
  },
  // 내 휴지통
  { path: "/total-trash-can", name: "TotalTrashCan",
    component: () => import("../views/TotalTrashCan.vue"),
    beforeEnter: multiguard([onlyAfterLogin]),
  },
  // 리드 관리 (어드민 메뉴)
  { path: "/admin-menu", name: "AdminMenu",
    component: () => import("../views/AdminMenu.vue"),
    beforeEnter: multiguard([onlyAfterLogin, onlySuperAdmin]),
  },
  // 도움말
  { path: "/audit-log", name: "AuditLogAdmin",
    component: () => import("../views/AuditLogAdmin.vue"),
    beforeEnter: multiguard([onlyAfterLogin, onlySuperAdmin]),
  },
  // CS 이슈리포트 (FE mock)
  { path: "/cs-issues", name: "CSIssueList",
    component: () => import("../views/CSIssueReport/CSIssueList.vue"),
    beforeEnter: multiguard([onlyAfterLogin]),
  },
  { path: "/cs-issues/new", name: "CSIssueCreate",
    component: () => import("../views/CSIssueReport/CSIssueCreate.vue"),
    beforeEnter: multiguard([onlyAfterLogin]),
  },
  { path: "/cs-issues/:ticketId", name: "CSIssueDetail",
    component: () => import("../views/CSIssueReport/CSIssueDetail.vue"),
    beforeEnter: multiguard([onlyAfterLogin]),
  },
  { path: "/help", name: "Help",
    component: Help,
    beforeEnter: multiguard([onlyAfterLogin]),
  },

  // 업무 관리
  { path: "/work-management/:pk",
    name: "WorkManagementLayout",
    component: () => import("../views/WorkManagement/WorkManagementLayout.vue"),
    meta: { menuKey: 'work' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
    children: [
      { path: "", name: "WorkManagement",
        component: () => import("../views/WorkManagement/WorkManagement.vue"),
        meta: { menuKey: 'work' },
      },
      { path: "my-items", name: "MyWorkItems",
        component: () => import("../views/WorkManagement/MyWorkItems.vue"),
        meta: { menuKey: 'work' },
      },
      { path: "notifications", name: "WorkNotifications",
        component: () => import("../views/WorkManagement/WorkNotifications.vue"),
        meta: { menuKey: 'work' },
      },
      { path: "external-events", name: "WorkExternalEvents",
        component: () => import("../views/WorkManagement/WorkExternalEvents.vue"),
        meta: { menuKey: 'work' },
      },
      { path: "works/:work_id", name: "WorkDetail",
        component: () => import("../views/WorkManagement/WorkDetail.vue"),
        meta: { menuKey: 'work' },
      },
      { path: "items/:work_item_id", name: "WorkItemRedirect",
        component: () => import("../views/WorkManagement/WorkItemRedirect.vue"),
        meta: { menuKey: 'work' },
      },
      { path: "templates", name: "WorkTemplateLayout",
        component: () => import("../views/WorkManagement/WorkTemplateLayout.vue"),
        meta: { menuKey: 'work' },
        children: [
          { path: "", name: "WorkTemplateList",
            component: () => import("../views/WorkManagement/WorkTemplateList.vue"),
            meta: { menuKey: 'work' },
          },
          { path: "new", name: "WorkTemplateCreate",
            component: () => import("../views/WorkManagement/WorkTemplateCreate.vue"),
            meta: { menuKey: 'work' },
          },
          { path: ":template_id", name: "WorkTemplateDetail",
            component: () => import("../views/WorkManagement/WorkTemplateDetail.vue"),
            meta: { menuKey: 'work' },
          },
          { path: ":template_id/publish", name: "WorkTemplatePublish",
            component: () => import("../views/WorkManagement/WorkTemplatePublish.vue"),
            meta: { menuKey: 'work' },
          },
        ],
      },
    ],
  },

  // 타임라인
  { path: "/dashboard/:pk", name: "DashBoard",
    component: () => import("../views/TimeLine.vue"),
    meta: { menuKey: 'dashboard' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },

  // 데이터
  { path: "/data-management/:pk", name: "DataManagement",
    component: () => import("../views/Data.vue"),
    meta: { menuKey: 'data-management' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },

  // 프로세스 분석
  { path: "/process/:pk", name: "Process",
    component: () => import("../views/Process.vue"),
    meta: { menuKey: 'process' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },

  // 언어 관리
  { path: "/rpa-terminology/:pk", name: "RpaTerminology",
    component: () => import("../views/Rpa/RpaTerminology.vue"),
    meta: { menuKey: 'rpa2' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 통합 결과
  { path: "/rpa-total-result/:pk", name: "RpaTotalResult",
    component: () => import("../views/Rpa/RpaTotalResult.vue"),
    meta: { menuKey: 'rpa2' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 워크플로우 목록
  { path: "/rpa/:pk", name: "RpaList",
    component: () => import("../views/Rpa/RpaList.vue"),
    meta: { menuKey: 'rpa2' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  { path: "/rpa2/:pk",
    redirect: to => `/rpa/${to.params.pk}`,
  },
  { path: "/rpa-list/:pk",
    redirect: to => `/rpa/${to.params.pk}`,
  },
  { path: "/rpa-list2/:pk",
    redirect: to => `/rpa/${to.params.pk}`,
  },
  // 워크플로우
  { path: "/rpa/:pk/:rpa_pk", name: "RpaMain",
    component: () => import("../views/Rpa/RpaMain.vue"),
    meta: { menuKey: 'rpa2' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt, checkRpa]),
  },
  { path: "/rpa2/:pk/:rpa_pk",
    redirect: to => `/rpa/${to.params.pk}/${to.params.rpa_pk}`,
  },
  // 워크플로우 (new)
  { path: "/rpa3/:pk/:rpa_pk", name: "RpaMain3",
    component: () => import("../views/Rpa/RpaMain3.vue"),
    meta: { menuKey: 'rpa2' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt, checkRpa]),
  },

  // 견적서
  { path: "/estimate/:pk", name: "Estimate",
    component: () => import("../views/Estimate.vue"),
    meta: { menuKey: 'estimate' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 문서 폼 (템플릿 목록)
  { path: "/form-list/:pk", name: "FormList",
    component: () => import("../views/FormList.vue"),
    meta: { menuKey: 'estimate' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 문서 폼 (템플릿(문서 목록))
  { path: "/form/:pk/:form_pk", name: "Form",
    component: () => import("../views/Form.vue"),
    meta: { menuKey: 'estimate' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 테이블
  { path: "/table/:pk", name: "Table",
    component: () => import("../views/Table.vue"),
    meta: { menuKey: 'table' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },

  // 인사이트 목록
  { path: "/insight-list/:pk", name: "InsightList",
    component: () => import("../views/InsightList.vue"),
    meta: { menuKey: 'insight' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 인사이트
  { path: "/insight/:pk/:insight_pk?", name: "Insight",
    component: () => import("../views/Insight.vue"),
    meta: { menuKey: 'insight' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },

  // AI Agent
  { path: "/ai-agent/:pk", name: "AiAgent",
    component: () => import("../views/AiAgent.vue"),
    meta: { menuKey: 'ai-engine' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 비동기 작업 로그
  { path: "/ai-agent/:pk/:async_task_pk", name: "AsyncTaskLogDetail",
    component: () => import("../views/AsyncTaskLogDetail.vue"),
    meta: { menuKey: 'ai-engine' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },

  // 이메일 검증
  { path: "/email-verify/:pk", name: "EmailVerify",
    component: () => import("../views/EmailVerify.vue"),
    meta: { menuKey: 'email-verify' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },

  // 표 검출
  { path: "/table-detection/:pk", name: "TableDetection",
    component: () => import("../views/TableDetection.vue"),
    meta: { menuKey: 'table-detection' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 검출 결과
  { path: "/detection-result/:pk", name: "DetectionResult",
    component: () => import("../views/Data.vue"),
    meta: { menuKey: 'detection-result' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },

  // Inner DB
  { path: "/inner-db/:pk", name: "InnerDb",
    component: () => import("../views/InnerDb.vue"),
    meta: { menuKey: 'inner-db' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },

  // OCR
  { path: "/ocr/:pk", name: "Ocr",
    component: () => import("../views/Ocr.vue"),
    meta: { menuKey: 'ocr' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },

  // PDF 분류
  { path: "/pdf-classification/:pk", name: "PdfClassification",
    component: () => import("../views/PdfClassification.vue"),
    meta: { menuKey: 'pdf-classification' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },

  // 커스텀
  { path: "/custom/:pk", name: "Custom",
    component: () => import("../views/Custom.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // MOU 리스트
  { path: "/mou-list/:pk", name: "MouList",
    component: () => import("../views/MouList.vue"),
    meta: { menuKey: 'mou-list' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 법인판매현황
  { path: "/corporate-sales-status/:pk", name: "CorporateSalesStatus",
    component: () => import("../views/CorporateSalesStatus.vue"),
    meta: { menuKey: 'corporate-sales-status' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // IROS 검색
  { path: "/iros-search/:pk", name: "IrosSearch",
    component: () => import("../views/IrosSearch.vue"),
    meta: { menuKey: 'iros-search' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  
  // 정보추출
  { path: "/extraction/:pk/:level", name: "Extraction",
    component: () => import("../views/Extraction.vue"),
    meta: { menuKey: 'extraction' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 키워드
  { path: "/keyword/:pk/:level", name: "Keyword",
    component: () => import("../views/Keyword.vue"),
    meta: { menuKey: 'keyword' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 요약
  { path: "/summary/:pk/:level", name: "Summary",
    component: () => import("../views/Summary.vue"),
    meta: { menuKey: 'summary' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 텍스트 분석
  { path: "/scatter", name: "Scatter",
    component: () => import("../views/Scatter.vue"),
    meta: { menuKey: 'scatter' },
    beforeEnter: multiguard([onlyAfterLogin, checkMenuPermission]),
  },

  // 데이터 그룹화
  { path: "/data-grouping/:pk", name: "DataGrouping",
    component: () => import("../views/DataGrouping.vue"),
    meta: { menuKey: 'slicer' },
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },

  // 프로젝트 휴지통
  { path: "/project-trash-can/:pk", name: "ProjectTrashCan",
    component: () => import("../views/ProjectTrashCan.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt]),
  },
  // 프로젝트 관리
  { path: "/project-management/:pk", name: "ProjectManagement",
    component: () => import("../views/ProjectManagement.vue"),
    beforeEnter: multiguard([onlyAfterLogin, checkPjt, onlyOwner]),
  },

  // 개인정보 처리방침
  { path: "/privacy-policy", name: "PrivacyPolicy",
    component: () => import("../views/PrivacyPolicy.vue"),
  },
  // 이용약관
  { path: "/terms", name: "Terms",
    component: () => import("../views/Terms.vue"),
  },

  // page-not-found
  { path: "/page-not-found", name: "NotFound",
    component: () => import("../views/NotFound.vue"),
  },
  { path: "*", redirect: "/page-not-found",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // 라우트가 변경되기 직전에 현재 열려있는 Swal을 모두 닫음
  if (keepSwalOnNextRouteChange) {
    keepSwalOnNextRouteChange = false
  } else {
    Swal.close();
  }

  // JWT 토큰 디코딩 및 만료 확인
  const isRefreshTokenExpired = (token) => {
    if (isCookieRefreshEnabled(store.state.auth_refresh_mode)) return false;
    // console.log('isRefreshTokenExpired', token, store.state.user_info)
    if (!token) return false;
    if (!store.state.user_info || (store.state.user_info && !store.state.user_info.user_type) || (store.state.user_info && store.state.user_info.user_type === 'google')) return false

    try {
      const exp = jwtDecode(token).exp
      const date_now = Date.now() / 1000 // 밀리초(ms) -> 초(s) 변환
      const bufferTime = 5 * 60 // 5분(300초) 여유시간
      return date_now + bufferTime > exp;
    } catch {
      return false;
    }
  };

  if (isRefreshTokenExpired(store.state.refresh_token)) {
    store.commit('logout')
    next('/');
  } else {
    next();
  }
});


export default router;
